import { isCancel } from 'Helpers/apiWrapper'
import { logAppError } from 'Helpers/logger'
import { regexEmail } from 'mailup-react-helpers'
import {
  TRUSTED_EMAIL_INPUT_VARIANT_INVALID,
  TRUSTED_EMAIL_INPUT_VARIANT_NEUTRAL,
  TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
} from 'mailup-web-components'

import {
  fetchHideDelivStatus,
  fetchStatus,
  registerSender,
  setHideDelivStatus
} from './actions'
import mapStatusToVariant from './mapStatusToVariant'
import { trustedEmailSenderState } from './state'

export const onChangeValueCallback =
  ({ set, snapshot }) =>
  async (itemKey, cancelToken) => {
    const { value, required } = await snapshot.getPromise(
      trustedEmailSenderState(itemKey)
    )

    try {
      const validRequired = required ? !!value : true
      const validEmail = value && value.match(regexEmail)

      if (validEmail) {
        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          invalidRequired: false,
          invalidFormat: false
        }))

        const [statusResult, hideDelivStatus] = await Promise.all([
          fetchStatus(value, cancelToken),
          fetchHideDelivStatus(value)
        ])

        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          variant: mapStatusToVariant(statusResult, hideDelivStatus),
          status: statusResult
        }))
      } else {
        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          invalidRequired: !validRequired,
          invalidFormat: !validEmail,
          variant:
            validRequired && validEmail
              ? TRUSTED_EMAIL_INPUT_VARIANT_NEUTRAL
              : TRUSTED_EMAIL_INPUT_VARIANT_INVALID
        }))
      }
    } catch (error) {
      if (isCancel(error)) {
        //  do nothing
      } else {
        logAppError({
          appError: error,
          Component: 'useTrustedEmailSender',
          Method: 'innerHandleChange'
        })

        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          isError: true
        }))
      }
    }
  }

export const registerSenderCallback =
  ({ set, snapshot }) =>
  async (itemKey, cancelToken, onRegisterSuccess, onRegisterError) => {
    const { value } = await snapshot.getPromise(
      trustedEmailSenderState(itemKey)
    )

    try {
      await registerSender(value, cancelToken)

      set(trustedEmailSenderState(itemKey), (prev) => ({
        ...prev,
        pollingIteration: 1,
        pollingError: false
      }))

      typeof onRegisterSuccess === 'function' && onRegisterSuccess()
    } catch (error) {
      if (isCancel(error)) {
        //  do nothing
      } else {
        logAppError({
          appError: error,
          Component: 'useTrustedEmailSender',
          Method: 'registerSenderCallback'
        })

        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          pollingIteration: 0,
          pollingError: true
        }))

        typeof onRegisterError === 'function' && onRegisterError()
      }

      /*
     
      */
    }
  }

export const statusPollingCallback =
  ({ set, snapshot }) =>
  async (itemKey, cancelToken) => {
    const { value } = await snapshot.getPromise(
      trustedEmailSenderState(itemKey)
    )

    try {
      const statusResult = await fetchStatus(value, cancelToken)

      set(trustedEmailSenderState(itemKey), (prev) => ({
        ...prev,
        variant: mapStatusToVariant(statusResult, false),
        status: statusResult,
        pollingError: false,
        pollingIteration: prev.pollingIteration + 1
      }))
    } catch (error) {
      if (isCancel(error)) {
        //  do nothing
      } else {
        logAppError({
          appError: error,
          Component: 'useTrustedEmailSender',
          Method: 'statusPollingCallback'
        })

        set(trustedEmailSenderState(itemKey), (prev) => ({
          ...prev,
          pollingIteration: 0,
          pollingError: true
        }))
      }
    }
  }

export const dismissWarningCallback =
  ({ set, snapshot }) =>
  async (itemKey) => {
    const { value } = await snapshot.getPromise(
      trustedEmailSenderState(itemKey)
    )
    try {
      await setHideDelivStatus(value)
    } catch (error) {
      logAppError({
        appError: error,
        Component: 'useTrustedEmailSender',
        Method: 'dismissWarningCallback'
      })
    }

    set(trustedEmailSenderState(itemKey), (prev) => ({
      ...prev,
      variant: TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
    }))
  }
